import { useI18n } from '../i18n/useI18n'

export function LanguageToggle() {
  const { lang, setLang } = useI18n()

  return (
    <button
      type="button"
      onClick={() => setLang(lang === 'en' ? 'zh' : 'en')}
      className="font-label-sm text-label-sm text-on-surface-variant hover:text-primary transition-colors duration-200"
    >
      {lang === 'en' ? 'EN / 中文' : '中文 / EN'}
    </button>
  )
}
